import { motion } from 'motion/react'
import { Switch as SwitchPrimitive } from 'radix-ui'
import type * as React from 'react'
import { springs } from '@/lib/motion/presets'
import { cn } from '@/lib/utils'

export function Switch({
  className,
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root>) {
  return (
    <SwitchPrimitive.Root
      className={cn(
        'peer inline-flex h-6 w-11 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent px-0.5 shadow-sm transition-[color,box-shadow] focus-visible:outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:justify-end data-[state=checked]:bg-primary data-[state=unchecked]:justify-start data-[state=unchecked]:bg-input',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb asChild>
        <motion.span
          layout
          transition={springs.switchThumb}
          className="pointer-events-none block size-5 rounded-full bg-background shadow-lg ring-0"
        />
      </SwitchPrimitive.Thumb>
    </SwitchPrimitive.Root>
  )
}
